<template>
    <v-container
        fluid
        fill-height
    >
        <v-layout
            align-center
            justify-center
        >
            <v-flex
                xs12
                sm8
                md8
            >
                <v-row no-gutters>

                    <v-col cols="12" xl="7" md="7" sm="12" class="text-center pa-5 white--text">

                        <v-img class="cover-img" src="../../assets/firme/bg-logo.png"></v-img>
                        <h1>Контактирајте нас</h1>
                        <h2>Уколико сте у могућности да донирате средства или да помогнете у волонтирању, молимо Вас
                            контактирајте нас путем контакт форме или броја телефона.</h2>
                        <!-- <v-img  src="../../assets/company.svg"></v-img>-->
                    </v-col>
                    <v-col cols="12" xl="5" md="5" sm="12" class="d-flex align-center">
                        <v-card class="pa-5 w-full">
                            <v-form
                                @submit.prevent="contactForm"
                                ref="form"
                                v-model="valid"
                                lazy-validation
                            >
                                <v-text-field
                                    label="E-mail адреса"
                                    type="email"
                                    v-model="form.email"
                                    :rules="[requiredRule, emailRules]"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    label="Лично име и презиме"
                                    v-model="form.name"
                                    :rules="[requiredRule]"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="form.phoneNumber"
                                    label="Број телефона"
                                    :rules="[requiredRule]"
                                    type="text"
                                    required
                                ></v-text-field>

                                <v-textarea
                                    v-model="form.message"
                                    label="Остави поруку"
                                    :rules="[requiredRule]"
                                    required
                                ></v-textarea>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" color="primary" :disabled="!valid">Пошаљи</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
  import axios from 'axios'
  export default {
    name: 'Companies',

    data: () => ({
      requiredRule: v => !!v || 'Ово поље је неопходно',
        emailRules: v => /.+@.+\..+/.test(v) || 'Имејл није валидан',
        valid: true,
        recaptcha: '',
        form: {
            email: '',
            name: '',
            phoneNumber: '',
            message: '',
            recaptcha: ''
        }

    }),
      async mounted(){
          await this.$recaptchaLoaded()
          let recaptchaInstance = this.$recaptchaInstance
          recaptchaInstance.hideBadge()
      },
    methods: {
            async contactForm(){
                await this.$refs.form.validate()
                if(this.valid) {
                    let token = await this.$recaptcha('login')
                    this.form.recaptcha = token
                  axios.post('/contact', {...this.form})
                    .then(() => {
                    this.$swal({ title: "Ваш порука је успешно послата!", type: "success" })
                        this.$refs.form.reset()
                    })
                    .catch(err => {
                      this.$toasted.global.resp_err({ message: err.response.data.message });
                    })
                }
        },
    }
  }
</script>
<style scoped>
    .cover-img{
        margin: 0 auto;
    }
    h1 {
        padding: 25px 0;
        font-size: 56px;
        font-weight: 700;
        line-height: 1;
    }

    .container.fill-height {
        background: #0d4077 !important;
    }

    .contact-section {
        color: white;
    }

    .contact-section .row.text-center.no-gutters {
        padding: 47px 0;
    }

    @media only screen and (max-width: 768px) {
        h1 {
            font-size: 25px;
        }

        h2 {
            font-size: 18px !important;
            font-weight: 400;
        }
    }
</style>
